import React from 'react';
import { BooleanField, ResourceContextProvider, useRecordContext, useTranslate } from 'react-admin';
import { IconButton, makeStyles, Table, TableBody } from '@material-ui/core';
import { Close } from '@material-ui/icons';

import Row from '../../../../common/cards/TableRow';
import InfoCard from '../../../../common/cards/InfoCard';
import TimeRangeField from '../../../../common/fields/TimeRangeField';
import TextArrayField from '../../../../common/fields/TextArrayField';
import { EventDetailsPopover } from '../../../../common/calendar/EventDetailsPopover';

import { SurfaceField } from '../../../surfaces/SurfaceField';
import { CategoriesField } from '../../../categories/CategoriesField';
import { OfficesField } from '../../../offices/OfficesField';
import { TeamsField } from '../../../teams/TeamsField';

const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(1),
    minWidth: theme.spacing(50),
  },
  row: {
    paddingTop: theme.spacing(.5),
    paddingBottom: theme.spacing(.5),
    borderBottom: 'none',
  },
}));

const TITLE_MAP = {
  Practice: 'resources.practices.name',
  Timeslot: 'resources.arenaslots.name',
};

const CloseButton = ({ handleClose }) => {
  return <IconButton size="small" onClick={handleClose}>
    <Close fontSize="medium" />
  </IconButton>
}

const SlotDetails = ({ handleClose }) => {
  const translate = useTranslate();
  const slot = useRecordContext();
  const classes = useStyles();

  const { eventType, name, categoryIds, types, leagueIds, teamIds, isShared } = slot;

  return <ResourceContextProvider value="arenaslots">
    <InfoCard
      title={translate(TITLE_MAP[eventType], 1)}
      subtitle={name}
      headerAction={[<CloseButton handleClose={handleClose} />]}
    >
      <Table className={classes.root}>
        <TableBody>
          <Row cellClass={classes.row} label="ra.date.time">
            <TimeRangeField startSource="startTime" endSource="endTime" />
          </Row>
          <Row cellClass={classes.row} label="resources.arenaslots.fields.arenaId">
            <SurfaceField source="surfaceId" includeAttributes="full" includeCity="full" />
          </Row>
          <Row hidden={!categoryIds?.length} label="resources.arenaslots.fields.categoryIds" cellClass={classes.row}>
            <CategoriesField source="categoryIds" />
          </Row>
          <Row hidden={!types?.length} label="resources.arenaslots.fields.types" cellClass={classes.row}>
            <TextArrayField source="types" />
          </Row>
          <Row hidden={!leagueIds?.length} label="resources.arenaslots.fields.leagueIds" cellClass={classes.row}>
            <OfficesField source="leagueIds" />
          </Row>
          <Row hidden={!teamIds?.length} label="resources.practices.fields.teamIds" cellClass={classes.row}>
            <TeamsField source="teamIds" />
          </Row>
          <Row hidden={!isShared} label="ra.message.shared_slot" cellClass={classes.row} >
            <BooleanField source="isShared" />
          </Row>
        </TableBody>
      </Table>
    </InfoCard>
  </ResourceContextProvider>
}

const SlotDetailsPopover = ({ children, ...props }) => {
  return <EventDetailsPopover popoverContent={(handleClose) => <SlotDetails handleClose={handleClose} {...props} />} {...props}>
    {children}
  </EventDetailsPopover>
}

export default SlotDetailsPopover;
